import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Always refetch on mount so navigating back to a list page (e.g. after
      // creating/editing a record elsewhere) shows current data instead of the
      // stale cache from before the staleTime window elapses.
      refetchOnMount: 'always',
      retry: 1,
      staleTime: 5 * 60 * 1000, // Data remains fresh for 5 minutes
    },
  },
});

export const QueryProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};
